import React from "react";

function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Privacy Policy</h1>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to ServiGo ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclosure, and safeguard your information when you use our appliance repair services.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect personal information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Register an account or sign up for our services</li>
            <li>Book a repair service for your appliance</li>
            <li>Contact our customer support</li>
            <li>Participate in surveys or promotions</li>
          </ul>
          <p>The personal information we collect may include:</p>
          <ul>
            <li>Name, email address, phone number, and postal address</li>
            <li>Appliance details (type, brand, model, problem description)</li>
            <li>Payment information (processed securely through third-party providers)</li>
            <li>Service history and booking records</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect or receive:</p>
          <ul>
            <li>To provide, maintain, and improve our repair services</li>
            <li>To process your bookings and facilitate service appointments</li>
            <li>To communicate with you about your bookings, inquiries, and support requests</li>
            <li>To send you technical notices, updates, and administrative information</li>
            <li>To respond to your comments, questions, and provide customer service</li>
            <li>To analyze usage patterns and improve user experience</li>
            <li>To comply with legal obligations and enforce our terms</li>
          </ul>
        </section>

        <section>
          <h2>4. Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul>
            <li><strong>Service Technicians:</strong> To enable them to perform repairs at your location</li>
            <li><strong>Third-Party Service Providers:</strong> For payment processing, booking management, and customer support</li>
            <li><strong>Legal Authorities:</strong> When required by law or in response to valid requests</li>
          </ul>
          <p>We do NOT sell your personal information to third parties.</p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate personal information</li>
            <li>Request deletion of your personal information (subject to legal requirements)</li>
            <li>Opt-out of marketing communications</li>
            <li>Withdraw consent where processing is based on consent</li>
          </ul>
        </section>

        <section>
          <h2>7. Data Retention</h2>
          <p>
            We will retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
          </p>
        </section>

        <section>
          <h2>8. Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          <ul>
            <li>Email: support@servigo.in</li>
            <li>Phone: 7970503756</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
